import CommentsApi from '@/api/comments';


const getDefaultState = () => ({
  loading: false,
  comments: [],
  pagination: {
    page: 0,
    perPage: 10,
  },
  hasMore: true,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setComment(state, payload) {
      state.comments = state.comments.concat(payload);
      if (payload.length < state.pagination.perPage) {
        state.pagination.page = 0;
        state.hasMore = false;
      } else {
        state.pagination.page += 1;
      }
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    },
    insertRootComment(state, payload) {
      state.comments.unshift(payload);
    },
  },
  actions: {
    async findByContentId({ commit, dispatch }, { contentId }) {
      try {
        commit('setLoading', true);
        const { data } = await CommentsApi.findByContentId(contentId);
        commit('setComment', data);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      } finally {
        commit('setLoading', false);
      }
    },
    insertRootComment({ commit, rootGetters }, payload) {
      const owner = rootGetters['user/user'];
      commit('insertRootComment', {
        ...payload,
        owner,
        ownerId: owner.id,
        replies: [],
        likes: [],
      });
    },
  },
  getters: {
    loading: state => state.loading && !state.comments.length,
    loadMoreLoading: state => state.loading && !!state.comments.length,
    comments: state => state.comments,
    pagination: state => state.pagination,
    hasMore: state => state.hasMore,
  },
};
